import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, output, inject } from '@angular/core';
import { ReCaptchaService } from '@app/core/recaptcha/re-captcha.service';
import { Subscription } from 'rxjs';
import { RecaptchaData } from '@app/core/recaptcha/recaptcha-commons';

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.scss'],
})
export class RecaptchaComponent implements AfterViewInit, OnDestroy {
  private recaptchaService = inject(ReCaptchaService);

  @ViewChild('container') public container: ElementRef;

  public readonly data = output<RecaptchaData>();

  private subscription = new Subscription();

  public ngAfterViewInit(): void {
    const sub = this.recaptchaService.createCheckbox(this.container.nativeElement)
      .subscribe(
        data => this.data.emit(data),
      );
    this.subscription.add(sub);
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
